import React from 'react';
import { ZodEffects, ZodObject, ZodString } from 'zod';
import * as EditableTextAreaUI from './EditableTextAreaUI';
import EditableTextArea from './EditableTextArea';
import EditableTextAreaValue from './EditableTextAreaValue';
import { IconWrapper } from '../Icon';

interface IProps {
  disabled: boolean;
  placeholder: string;
  value: string;
  validation: ZodObject<{ value: ZodEffects<ZodString, string, string> }>;
  defaultRows?: number;
  isBold?: boolean;
  isRenamed?: boolean;
  onChange: (newVal: string) => void;
  startEditable?: boolean;
  isReadOnly?: boolean;
}

const EditableTextAreaController = ({
  isReadOnly,
  disabled,
  ...props
}: IProps) => {
  if (isReadOnly || disabled) {
    if (!props.value.length) {
      return <div />;
    }

    return (
      <EditableTextAreaUI.ValueContainer $isReadOnly={true}>
        <EditableTextAreaValue
          isBold={props.isBold}
          isRenamed={props.isRenamed}
          value={props.value}
        />
        <IconWrapper size={16} />
      </EditableTextAreaUI.ValueContainer>
    );
  }

  return <EditableTextArea {...props} />;
};

export default EditableTextAreaController;
